import { IRoleType } from "@/models/role";
import { lazy } from "react";

import RouteGuard from "@/components/RouteGuard";
const Clinic = lazy(() => import("@/views/PharmacyClinicDiagnostic/Clinic"));

const ClinicRoutes = [
  {
    path: "/clinic-patient",
    component: (
      <RouteGuard allowedRoles={[IRoleType.PHARMACY]}>
        <Clinic />
      </RouteGuard>
    ),
  },
];

export default ClinicRoutes;
